/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from 'react';
import FormulaForm from './FormulaForm';
import TemplateForm from './TemplateForm';
import AssignForm from './AssignForm';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import classes from './CalculatedSensor.module.css';
import * as DashboardActions from '../../../actions/dashboardActions';
import * as BobActions from '../../../actions/bobActions';


const CalculatedSensorForm = ({
    activeNavClient,
    activeNavEquipment,
    activeNavSite,
    currentUser,
    agents,
    bobLoading,
    ...props
}) => {

    const getInitialState = () =>{
        return currentUser.isSuperUser ? 'Formula':'Template';
    };

    const [tab,setTab] = useState( '');

    const handleTabClick  = (tab)=>{
        setTab(tab);
        props.setSelectedTab(tab);
    };

    useEffect(() => {
        let tab = getInitialState();
        setTab(tab);
        props.setSelectedTab(tab);
    }, [currentUser]);

    return (
        <div className={classes.SensorForm}>
            <div className={classes.FormContainer}>
                <div className={classes.TabPanel}>
                    {currentUser && currentUser.isSuperUser ?
                        <div
                            tabIndex="0" role="button" className={`${classes.Tabs} ${tab === 'Formula'? classes.ActiveTab :''}`}
                            onClick={() =>handleTabClick('Formula')}
                        >
                            Formula
                        </div>
                        :''}
                    <div
                        tabIndex="0" role="button" className={`${classes.Tabs} ${tab === 'Template'?classes.ActiveTab :''}`}
                        onClick={() =>handleTabClick('Template')}
                    >
                        Template
                    </div>
                    <div
                        tabIndex="0" role="button" className={`${classes.Tabs} ${tab === 'Assign'?classes.ActiveTab :''}`}
                        onClick={() =>handleTabClick('Assign')}
                    >
                        Assign
                    </div>
                </div>
              
            </div>
            <div>
                {tab === 'Formula' && currentUser.isSuperUser ? <FormulaForm />:''}
                {tab === 'Template'? <TemplateForm />:''}
                {tab === 'Assign'? <AssignForm />:''}
            </div>
           
        </div>
    );
};

const mapStateToProps = ({ basAgent, ...state }) => {
    const { basAgents } = basAgent;

    return {
        activeNavEquipment: state.bob.activeNavEquipment,
        activeNavClient:    state.bob.activeNavClient,
        activeNavSite:      state.bob.activeNavSite,
        agents:             Object.values(basAgents),
        currentUser:        state.currentUser,
        bobLoading:         state.bob.bobLoading
    };
};

const mapDispatchToProps = {
    ...BobActions,
    ...DashboardActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CalculatedSensorForm));
